import { BannerPortal } from 'app/agriculture/Banner/BannerPortal';

export function AgricultureMainBanner() {
    return (
        <div className="AgricultureMain__banner">
            <BannerPortal />
        </div>
    );
}
